var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpaMascotas(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 159.183,
    height: 200,
    viewBox: "0 0 159.183 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #24303c;\r\n        stroke: #24303c;\r\n      }\r\n\r\n      .cls-2 {\r\n        clip-path: url(#clip-path);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    className: "cls-1",
    width: 159.183,
    height: 200
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PetPark",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    className: "cls-2",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    className: "cls-1",
    d: "M158.077,68.495,143.023,40.083a18.51,18.51,0,0,0-16.393-9.862H85.117V13.114a13.114,13.114,0,0,0-26.229,0V30.221H7.912A7.92,7.92,0,0,0,0,38.131v70.756A7.919,7.919,0,0,0,7.912,116.8H58.889v60.019H26.86a6.41,6.41,0,0,0-6.4,6.4V193.6a6.411,6.411,0,0,0,6.4,6.4h90.285a6.413,6.413,0,0,0,6.4-6.4V183.218a6.411,6.411,0,0,0-6.4-6.4H85.117V116.8h41.389A18.475,18.475,0,0,0,143,106.728L158.134,77.3a9.521,9.521,0,0,0-.057-8.8M67.066,13.114a4.937,4.937,0,0,1,9.874,0V30.221H67.066ZM83.343,184.993h32.028v6.832H28.635v-6.832H60.663a6.411,6.411,0,0,0,6.4-6.4V116.8H76.94V178.59a6.41,6.41,0,0,0,6.4,6.4M150.861,73.559l-15.126,29.43a10.338,10.338,0,0,1-9.228,5.63H8.177V38.4H126.629a10.348,10.348,0,0,1,9.167,5.516l15.054,28.41a1.332,1.332,0,0,1,.01,1.235",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    className: "cls-1",
    d: "M42.05,37.206a6.214,6.214,0,0,0,6.213-6.213V27.886a6.213,6.213,0,1,0-12.425,0v3.107a6.214,6.214,0,0,0,6.213,6.213",
    transform: "translate(37.425 22.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    className: "cls-1",
    d: "M32.932,37.206a6.212,6.212,0,0,0,6.213-6.213V27.886a6.213,6.213,0,0,0-12.425,0v3.107a6.214,6.214,0,0,0,6.213,6.213",
    transform: "translate(27.903 22.633)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    className: "cls-1",
    d: "M48.128,29.271a6.212,6.212,0,0,0-6.213,6.213v3.107a6.213,6.213,0,1,0,12.425,0V35.484a6.214,6.214,0,0,0-6.213-6.213",
    transform: "translate(43.773 30.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    className: "cls-1",
    d: "M33.066,38.591V35.484a6.213,6.213,0,1,0-12.425,0v3.107a6.213,6.213,0,0,0,12.425,0",
    transform: "translate(21.556 30.567)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    className: "cls-1",
    d: "M52.14,36.382h0a9.227,9.227,0,0,0-14.686,0L26.165,51.217A9.227,9.227,0,0,0,33.508,66.03H56.086a9.225,9.225,0,0,0,7.341-14.811Z",
    transform: "translate(25.358 34.191)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaMascotas);
export default __webpack_public_path__ + "static/media/SpaMascotas.d07882b6c8ff51bf81bfd0096c91129c.svg";
export { ForwardRef as ReactComponent };